module.exports = __webpack_public_path__ + "static/media/FM.0b3bcc7b.svg";